<template>
  <v-menu
    v-model="menu"
    min-width="260px"
    max-width="260px"
    :close-on-content-click="false"
    content-class="UXDatapicker"
  >
    <template v-slot:activator="{ on }">
      <div class="UXdateInput" v-on="on" style="min-width: 120px">
        <span class="inpTxt" style="width: 90px" v-if="picker !== ' '">{{ picker }}</span>
        <span class="inpTxt" style="width: 90px" v-else>0000-00-00 ~ 0000-00-00</span>
        <i class="UXicon-calendar"></i>
      </div>
    </template>
    <div class="viewPicker month">
      <div class="pickerHead month">
        {{ viewPicker }}
      </div>
      <v-date-picker
        :class="`schedulePicker ${pickerClass}`"
        locale="jp"
        v-model="picker"
        full-width
        no-title
        show-current="false"
        @change="menu = false"
        :day-format="getDayFormat"
        :header-date-format="getMonthFormat"
        :allowed-dates="allowedDates"
      ></v-date-picker>
    </div>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateOneDayPicker',
  data () {
    return {
      menu: false,
      viewPicker: moment().format('YYYY年 MM月 DD日'),
      picker: '',
      pickerClass: 'day'
    }
  },
  props: {
    // -1일 관리 boolean값
    subtract: {
      type: Boolean,
      default: false
    },
    customerBirth: {
      type: String,
      default: moment().format('YYYY-MM-DD')
    }
  },
  watch: {
    picker: {
      immediate: true,
      handler () {
        const splitMonth = this.picker.split('-')
        this.viewPicker = `${splitMonth[0]}年 ${splitMonth[1]}月 ${splitMonth[2]}日`
        this.$emit('update', this.picker)
      }
    },
    menu () {
      this.$emit('show', this.menu)
    },
    customerBirth (val) {
      this.picker = val
    }
  },
  computed: {
  },
  mounted () {
    this.setPickerValue()
  },
  methods: {
    getMonthFormat (date) {
      let dateArr = date.split('-')
      if (dateArr.length !== 1) {
        this.pickerClass = 'day'
        return `${dateArr[0]}.${dateArr[1]}`
      }
    },
    getDayFormat (date) {
      return moment(date).format('YYYY-MM-D').split('-')[2]
    },
    initDay () {
      this.picker = moment().format('YYYY-MM-DD')
    },
    allowedDates (date) {
      return moment(moment(date).format('YYYY-MM-DD')).diff(moment().format('YYYY-MM-DD')) <= 0
    },
    setPickerValue () {
      this.picker = this.subtract ? moment().subtract(1, 'day').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DateOneDayPicker.vue